export const stripValueToOnlyHaveNumbers = (state) => state.toString().replace(/\D/g, '').toString();

export const isValidMonth = (month) => {
  const pattern = /^(0?[1-9]|1[012])$/;
  const regex = new RegExp(pattern);
  return regex.test(month);
};

export const isValidDay = (day) => {
  const pattern = /^(0?[1-9]|[12]\d|3[01])$/;
  const regex = new RegExp(pattern);
  return regex.test(day);
};

export const isValidYear = (year) => {
  const pattern = /^(19\d\d|20[01]\d)$/;
  const regex = new RegExp(pattern);
  return regex.test(year);
};

export const isValidIncome = (income) => {
  const pattern = /^\d{1,7}$/;
  const regex = new RegExp(pattern);
  return regex.test(income) && income < 1200000 && income >= 1;
};

export const isValidZipCode = (zipCode) => {
  const pattern = /^\d{5}(-\d{4})?$/;
  const regex = new RegExp(pattern);
  return regex.test(zipCode);
};

export const isValidPostalCode = (postalCode) => {
  const pattern = /^[a-zA-Z]\d[a-zA-Z][-\s]?\d[a-zA-Z]\d$/;
  const regex = new RegExp(pattern);
  return regex.test(postalCode);
};

export const isValid5DigitZipCode = (zipCode) => {
  const pattern = /^\d{5}$/;
  const regex = new RegExp(pattern);
  return regex.test(zipCode);
};
export const isValidEmail = (email) => {
  const pattern = /^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}\s*$/;
  const regex = new RegExp(pattern);
  return regex.test(email);
};

export function isValidName(name) {
  const pattern = /^[a-zA-Z]+(([',.\-\s])?[a-zA-Z]+)+(\s)?$/;
  const regex = new RegExp(pattern);
  return regex.test(name);
}

export function isValidPhone(phone) {
  const pattern = /^(\(?\d{3}\)?\s*-?\d{3}\s*-?\d{4})$|^$/;
  const regex = new RegExp(pattern);
  return regex.test(phone);
}

export function isValidStreetAddress(name, modalUpdateFlag) {
  const pattern = modalUpdateFlag ? /^[A-Za-zÀ-Ÿ0-9, ]*$/ : /^[A-Za-zÀ-Ÿ0-9 ]*$/;
  const regex = new RegExp(pattern);
  return name.length > 4 && regex.test(name);
}

export function hasTrailingSpaces(name) {
  const pattern = /^[A-Za-z0-9]([A-Za-z0-9 ]*[A-Za-z0-9])?$/;
  const regex = new RegExp(pattern);
  return !regex.test(name);
}

export function isValidCity(name) {
  const pattern = /^[a-zA-Z' ]+(?:[\\s-][a-zA-Z]+)*$/;
  const regex = new RegExp(pattern);
  return regex.test(name);
}

export function isValidCanadianCity(city) {
  const pattern = /^[a-zA-ZÀ-Ÿ' ]+(?:[\\s-][a-zA-ZÀ-Ÿ]+)*$/;
  const regex = new RegExp(pattern);
  return regex.test(city);
}
